import React             from 'react';
import { Redirect }      from 'react-router-dom';
import Notification from './Notification';

export const NotificationConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path     : '/notification/:view_type/:notification_id',
            component: Notification,
        },
        {
            path     : '/notification/:view_type/',
            component: Notification,
        },
        {
            path     : '/notification',
            component: () => <Redirect to="/notification/list" />,
        }
    ]
};


// WEBPACK FOOTER //
// src/main/content/notification/NotificationConfig.js